import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const RunCodeApi = createApi({
  reducerPath: "runCodeApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    postCodeApi: builder.mutation({
      query: ({ questionId, questionVersion, body }: any) => ({
        url: `/authTestcase?questionId=${questionId}&questionVersion=${questionVersion}`,
        method: "POST",
        body: body
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    getAllExecutionQl: builder.query({
      query: ({ questionId, version, fetchType }: any) => {
        return {
          url: "/graphql",
          body: gql`
                query GetAllExecutionQl{ 
    getAllExecutionQl(
        questionId: "${questionId}"
        version: ${version}
        fetchType: "${fetchType}"
    ) {
        timestamp
        data {
            executionId
            passedTestcases
            initiatedTestcases
            compileErrorTestcases
            runtimeErrorTestcases
            failedTestcases
            timeoutTestcases
        }
        error
        version
    }

                }
              `
        };
      },
      extraOptions: { service: "MCQ_Assessment" }
    }),
    getCompiledCode: builder.query({
      query: ({ executionId }: any) => {
        return {
          url: "/graphql",
          body: gql`
                query GetCompiledCodeQl {
    getCompiledCodeQl(executionId: "${executionId}") {
        timestamp
        error
        version
        data {
            questionId
            questionVersion
            testcaseId
            code
            status
            compilerOutput
            language
            totalMarks
            obtainedMarks
            executionId
        }
    }
}
              `
        };
      },
      extraOptions: { service: "MCQ_Assessment" }
    })
  })
});

export const {
  usePostCodeApiMutation,
  useGetAllExecutionQlQuery,
  useLazyGetAllExecutionQlQuery,
  useLazyGetCompiledCodeQuery
} = RunCodeApi;
